/** The fields of a history line that tell a lock line from a content line. */
export interface HistoryLineLike {
    oldTitle?: string | null;
    newTitle?: string | null;
    oldContent?: string | null;
    newContent?: string | null;
    /** Facade history lines carry `kind` for lock lines (lock | unlock | lock-readers-changed | lock-breakglass-read). */
    kind?: string | null;
}

const kindLabels: Record<string, string> = {
    lock: "Locked",
    unlock: "Unlocked",
    "lock-readers-changed": "Lock readers changed",
    "lock-breakglass-read": "Read through break-glass",
};

/**
 * The label of a lock line in a page's history, or undefined for a content line. Ark.Core writes lock lines with no content and no
 * titles (OrbitalPlan/18 §3); the legacy `GET …/History` route does not send their `kind`, so a line with neither is a lock change.
 */
export function historyLockLabel(line: HistoryLineLike): string | undefined {
    if (line.kind) return kindLabels[line.kind] ?? "Lock change";
    const isEmpty = !line.oldTitle && !line.newTitle && !line.oldContent && !line.newContent;
    return isEmpty ? "Lock change" : undefined;
}
